// Business Infor tabwith User resource counts-
import React, { useState, useEffect } from "react";
import {
    Typography,
    Grid,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@material-ui/core";

export default function BusinessInfoTab({ userData, userResourcesCount, handleTabChange }) {
    const [user, setUser] = useState(null);
    const [resourceCountName, setResourceCountName] = useState({
        "KnowledgeSessions_count": "Group Knowledge Sessions",
        "ExpertConsultations_count": "Expert Consultations",
        "MarketOpportunities_count": "Market Opportunities",
        "Compliances_count": "Compliances",
        "LoanReadiness_count": "Loan Readiness"
    })

    // useEffect(() => {
    //     if (userResourcesCount) {
    //         setUser(userResourcesCount);
    //     }
    // }, []);

    // if (!user) {
    //     return (
    //         <Typography variant="body1" color="textSecondary">
    //             Loading user business info...
    //         </Typography>
    //     );
    // }

    const purple = "rgb(118, 40, 124)";
    console.log(userResourcesCount, ">>>>userResourcesCount in business info tab");
    
    return (
        <div>
            {/* <Typography variant="h6" style={{ color: purple }} gutterBottom>
                Business Info for {user?.sFirstName || "User"} {user.sLastName || ""} 
            </Typography>

            <Paper style={{ padding: "16px", marginTop: "10px", borderLeft: `5px solid ${purple}` }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Business Sector:</strong> {user.sBusinessSector || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Business Started Year:</strong> {user.sBusinessStartedYear || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Family Income:</strong> {user.sFamilyIncome || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Business Pincode:</strong> {user.sBusinessPincode || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Location:</strong> {user.location || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    f9f6fb      <Typography><strong>Business Turnover:</strong> {user.sBusinessTurnover || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography>
                    </Grid>
                </Grid>
            </Paper> */}

            {/* Resource Count Table */}
            {userResourcesCount && (
                <Paper style={{ padding: "16px", marginTop: "20px", borderLeft: `5px solid ${purple}` }}>
                    <Typography variant="h6" style={{ color: purple }} gutterBottom>
                        User's Resources Counts
                    </Typography>
                    <div className="overflow-auto" style={{ height: "350px" }}>
                    <Table>
                        <TableHead>
                            <TableRow style={{ backgroundColor: `${purple}10` }}>
                                <TableCell style={{ color: purple }}><strong>Service</strong></TableCell>
                                <TableCell style={{ color: purple }}><strong>Count</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.entries(userResourcesCount).map(([key, value], index) => (
                                <TableRow key={key}>
                                    <TableCell>{resourceCountName[key]}</TableCell>
                                    <TableCell
                                        onClick={() => handleTabChange(null, index + 1)}
                                        style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        {value}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </div>
                    
                </Paper>
            )}
        </div>
    );
}
